import { guidebookSteps } from 'components/content/guidebook/content'
import { GuidebookIntro } from 'components/content/guidebook/guidebookIntro/GuidebookIntro'
import { GuidebookLP } from 'components/content/guidebook/GuidebookLP'
import { Footer } from 'components/footer/Footer'
import { TopNavigationLandingPage } from 'components/header/topNavigationLandingPage/TopNavigationLandingPage'
import { Layout } from 'components/layout/Layout'
import { PageMeta } from 'components/PageMeta'
import { PageTitle } from 'components/PageTitle'
import { Spacer } from 'components/spacer/Spacer'
import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { useSectionsInHash } from 'utils/hooks'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  const { t } = useTranslation('eol_guide')
  useSectionsInHash(guidebookSteps)

  return (
    <Layout
      header={<TopNavigationLandingPage variant="estate-planning" />}
      footer={<Footer variant="estate-planning" />}
    >
      <PageTitle title={t('eol_guide.meta_title')} />
      <PageMeta
        description={t('eol_guide.meta_description')}
        image="/images/preview/eol-guide.png"
      />

      <GuidebookIntro />

      <Spacer size={[4.5, 6]} />

      <GuidebookLP />
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx, 'eol_guide')) } }
}
